import { AGREE_TO_METERED_VISIT } from "./actionTypes";

export default (objectType) => ({
  type: AGREE_TO_METERED_VISIT,
  payload: {
    objectType,
  },
});
